// Runtime-context detection: which shell the web app is currently running in.
// Both checks are safe to call during SSR — they resolve to `false` on the server.
import { getNativeShellWindow } from '@trustoo/utils/nativeShell/shellWindow'

export function isPwa(): boolean {
    if (typeof window === 'undefined') {
        return false
    }
    // `display-mode: standalone` covers Android/desktop installs and iOS 16.4+.
    // Older iOS home-screen installs only expose the legacy, non-standard
    // `navigator.standalone` flag, so we fall back to it to avoid missing them.
    const isStandaloneDisplayMode =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(display-mode: standalone)').matches
    const isIosStandalone =
        (window.navigator as Navigator & { standalone?: boolean }).standalone === true
    return isStandaloneDisplayMode || isIosStandalone
}

/**
 * Returns true when the app is running inside the native mobile app WebView.
 * The native app injects window.__isNativeApp = true before the page loads.
 */
export function isNativeApp(): boolean {
    const nativeWindow = getNativeShellWindow()
    if (nativeWindow === null) {
        return false
    }
    return (
        nativeWindow.__isNativeApp === true ||
        typeof nativeWindow.ReactNativeWebView !== 'undefined' ||
        navigator.userAgent.includes('ReactNativeWebView')
    )
}
